<template>
  <validation-provider
    v-slot="{ errors }"
    :name="fieldName"
    rules="required"
  >
    <v-autocomplete
      :items="airports"
      :filter="customFilter"
      :error-messages="errors"
      color="blue"
      item-text="name"
      item-value="id"
      :label="$t('fields.'+fieldName)"
      v-bind="$attrs"
      v-on="$listeners"
      @change="changer"
    />
  </validation-provider>
</template>

<script>
  // Utilities
  import { call } from 'vuex-pathify'

  export default {
    name: 'AirportSelector',

    props: {
      fieldName: String,
    },

    data () {
      return {
        airports: [],
      }
    },
    mounted () {
      this.fetchDatasource({ sourceType: 'airports' }).then(response => {
        this.airports = response
      })
    },
    methods: {
      fetchDatasource: call('datasource/fetchDatasource'),
      customFilter (airport, queryText, itemText) {
        const textOne = airport.name.toLowerCase()
        const textTwo = airport.icao.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
      },
      changer (e) {
        console.log(e)
      },
    },
  }
</script>
